'use client'

import type { User } from '@/business/auth'
import { syncClientUserId } from '@/lib/userIdClient'
import { type ReactNode, createContext, useEffect, useState } from 'react'
import { getUser } from './getUser'

export const UserContext = createContext<User | null>(null)

export const UserProvider = ({ children }: { children: ReactNode }) => {
  const [user, setUser] = useState<User | null>(null)

  useEffect(() => {
    getUser()
      .then((response) => {
        if (response && typeof response === 'object') {
          syncClientUserId(response.id)
          setUser(response)
        } else {
          setUser(null)
        }
      })
      .catch((err) => {
        console.log('err', err)
      })
  }, [])

  return <UserContext.Provider value={user}>{children}</UserContext.Provider>
}
